import { useState } from 'react';
import { useLastCommit } from '../../hooks/useLastCommit';
import styles from './ProjectCommitStatus.module.css';

const ProjectCommitStatus = ({ status, statusType, githubOwner, repoName }) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const { lastCommitDate, isLoading, error, fetchLastCommit } = useLastCommit(
        githubOwner,
        repoName
    );

    const handleMouseEnter = () => {
        if (statusType === 'in-progress') {
            setShowTooltip(true);
            fetchLastCommit();
        }
    };

    const handleMouseLeave = () => {
        setShowTooltip(false);
    };

    // Если статус не "in-progress", показываем обычный статус
    if (statusType !== 'in-progress') {
        return (
            <div className={`${styles.projectStatus} ${styles[statusType]}`}>
                <span className={styles.statusDot}></span>
                <span>{status}</span>
            </div>
        );
    }

    // Для статуса "in-progress" показываем с тултипом
    return (
        <div
            className={`${styles.projectStatus} ${styles[statusType]}`}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <span className={styles.statusDot}></span>
            <span>{status}</span>

            {showTooltip && (
                <div className={styles.commitTooltip}>
                    {isLoading ? (
                        <div className={styles.tooltipLoading}>
                            <span className={styles.spinner}></span>
                            Загрузка...
                        </div>
                    ) : error ? (
                        <div className={styles.tooltipError}>
                            ⚠️ {error}
                        </div>
                    ) : lastCommitDate ? (
                        <div className={styles.tooltipContent}>
                            <span className={styles.tooltipIcon}>🕒</span>
                            <div>
                                <div className={styles.tooltipTitle}>Последняя активность</div>
                                <div className={styles.tooltipDate}>{lastCommitDate}</div>
                            </div>
                        </div>
                    ) : (
                        <div className={styles.tooltipError}>
                            📭 Нет данных о коммитах
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default ProjectCommitStatus;